import {
	Skeleton,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@dune/ui";
import React from "react";

const TemplatesTabSkeleton: React.FC = () => {
	return (
		<Table>
			<TableHeader>
				<TableRow>
					<TableHead>
						<Skeleton className="h-4 w-12" />
					</TableHead>
					<TableHead>
						<Skeleton className="h-4 w-24" />
					</TableHead>
					<TableHead>
						<Skeleton className="h-4 w-28" />
					</TableHead>
					<TableHead>
						<Skeleton className="h-4 w-20" />
					</TableHead>
					<TableHead>
						<Skeleton className="h-4 w-16" />
					</TableHead>
					<TableHead>
						<Skeleton className="h-4 w-16" />
					</TableHead>
					<TableHead>
						<Skeleton className="h-4 w-16" />
					</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{[
					"template-1",
					"template-2",
					"template-3",
					"template-4",
					"template-5",
				].map((key, index) => (
					<TableRow key={key}>
						<TableCell>
							<Skeleton className="h-4 w-32" />
						</TableCell>
						<TableCell>
							<Skeleton className="h-6 w-20 rounded-full" />
						</TableCell>
						<TableCell>
							<Skeleton className="h-6 w-36 rounded-full" />
						</TableCell>
						<TableCell>
							{index % 2 === 0 ? (
								<Skeleton className="h-6 w-24 rounded-full" />
							) : (
								<Skeleton className="h-4 w-2" />
							)}
						</TableCell>
						<TableCell>
							<Skeleton className="h-4 w-4" />
						</TableCell>
						<TableCell className="space-x-2">
							<div className="flex gap-1">
								<Skeleton className="h-6 w-16 rounded-full" />
								<Skeleton className="h-6 w-20 rounded-full" />
							</div>
						</TableCell>
						<TableCell className="space-x-2">
							<div className="flex gap-1">
								<Skeleton className="h-8 w-8" />
								<Skeleton className="h-8 w-8" />
								<Skeleton className="h-8 w-8" />
								<Skeleton className="h-8 w-8" />
							</div>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};

export default TemplatesTabSkeleton;
